
$(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
       $('.header-wrapper').addClass('scrolled_down');
    } else {
       $('.header-wrapper').removeClass('scrolled_down');
    }
});




$(document).ready(function () {
  $('.inner_flex_second').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,              // Enable autoplay
    autoplaySpeed: 3000,         // Time between slides in ms (3000 = 3s)
    speed: 600,                  // Transition speed (optional)
    pauseOnHover: true,          // Pause on hover (optional)
    pauseOnDotsHover: true       // Pause when hovering over dots (optional)
  });
});










  $(document).ready(function() {
    $('.featured_col_new').each(function(index) {
      var $section = $(this);
      var $slider = $section.find('.product-grid');
      var slideCount = $slider.find('.grid__item').length;

      // Only initialize slider if more than 5 items
      if (slideCount > 5) {
        var prevArrow = $section.find('.custom-prev');
        var nextArrow = $section.find('.custom-next');

        $slider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          dots: false,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 4
              }
            },

             {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }

      // Special case: if exactly 6 items, clone one to make it 7
      else if (slideCount === 6) {
        var newSlide = $slider.find('.grid__item').first().clone();
        $slider.append(newSlide); // Append to DOM first
        var prevArrow = $section.find('.custom-prev');
        var nextArrow = $section.find('.custom-next');

        $slider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  });


// Testimonial //

     $(document).ready(function(){
        $('.testimonial_slider_code').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          speed: 300,
          infinite: false, 
          prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
          autoplaySpeed: 5000,
          autoplay: true,
          responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
          }
        },

         {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },

        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
          
      ]
        });
      });




      // Faq tabs //


      document.addEventListener("DOMContentLoaded", function () {
  // ===== TAB SWITCHING =====
  const tabButtons = document.querySelectorAll(".faq-tab-button");
  const tabContents = document.querySelectorAll(".faq-tab-content");

  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const targetTab = button.dataset.tab;

      // Remove active classes
      tabButtons.forEach(btn => btn.classList.remove("active"));
      tabContents.forEach(content => content.classList.remove("active"));

      // Add active classes to selected tab and content
      button.classList.add("active");
      const targetContent = document.querySelector(
        `.faq-tab-content[data-tab-content="${targetTab}"]`
      );
      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });

  // ===== FAQ TOGGLE =====
  const titles = document.querySelectorAll(".js-faq-title");

  function slideDown(el) {
    el.style.display = "block";
    el.style.height = el.scrollHeight + "px";
    el.style.transition = "height 0.4s ease";
    el.style.overflow = "hidden";
  }

  function slideUp(el) {
    el.style.height = "0px";
    el.style.transition = "height 0.4s ease";
    el.style.overflow = "hidden";
  }

  titles.forEach(title => {
    title.addEventListener("click", function (e) {
      e.preventDefault();
      const content = this.nextElementSibling;
      const icon = this.querySelector(".js-faq-rotate");
      const isOpen = this.classList.contains("faq__active");

      // Close all other FAQ items
      titles.forEach(t => {
        t.classList.remove("faq__active");
        const i = t.querySelector(".js-faq-rotate");
        i.classList.remove("faq__rotate");
        slideUp(t.nextElementSibling);
      });

      // Toggle current item
      if (!isOpen) {
        this.classList.add("faq__active");
        icon.classList.add("faq__rotate");
        slideDown(content);
      }
    });
  });
});




$(document).ready(function() {
    var $shopWrap = $('.shop_home_main .home-shop-wrap');
    var itemCount = $shopWrap.children('.inner_grid').length;

    if (itemCount >= 5) {
        $shopWrap.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
});





$(document).ready(function() {
  const $slider = $('.shop_home_main .home-shop-wrap');
  const slideCount = $slider.find('.inner_grid').length;

  $slider.slick({
    dots: slideCount === 5,
    slidesToShow: 4, // or your preferred number
    slidesToScroll: 1,
    infinite: false,
    arrows: true, // optional
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});





document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('.custom-change-filter');
  const productGrid = document.getElementById('product-grid');

  if (!filterButtons.length || !productGrid) return;

  filterButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();

      // Remove existing grid classes
      productGrid.classList.remove(
        'grid--1-col-desktop',
        'grid--2-col-desktop',
        'grid--3-col-desktop',
        'grid--4-col-desktop'
      );

      // Add the new grid class from button's data attribute
      const newClass = button.getAttribute('data-class');
      if (newClass) {
        productGrid.classList.add(newClass);
      }

      // Toggle active class on buttons
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
    });
  });

  // Automatically trigger 2nd button on mobile
  if (window.innerWidth <= 768) {
    const secondButton = filterButtons[1];
    if (secondButton) {
      secondButton.click();
    }
  }
});


/*================================*/
  $(document).ready(function () {
    $('.accordion details').on('toggle', function () {
      const $this = $(this);

      if ($this.prop('open')) {
        // Remove active class from all
        $('.accordion').removeClass('active');

        // Add active to this one
        $this.closest('.accordion').addClass('active');

        // Optional: close others
        $('.accordion details').not(this).removeAttr('open');
      } else {
        $this.closest('.accordion').removeClass('active');
      }
    });
  });
/*================================*/